import Layout from "@/layouts";
import {i18n} from "@/utils/i18n";

const invoice = {
  path: "/invoiceInsurance",
  component: Layout,
  name: "invoiceInsurance",
  redirect: "/invoiceInsurance/index",
  children: [
    {
      path: "/invoiceInsurance/index",
      component: () => import("@/views/invoiceInsurance/index"),
      name: "invoiceInsurance.index",
      meta: { title: i18n.t(`message.invoice`) },
    },
  ],
};

export default invoice;
